export default __webpack_public_path__ + "static/media/curry.058f0003.png";